import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import { toast } from "react-toastify";
import Table_Buttons from "../Table_Button/Table_button";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { wait } from "@testing-library/user-event/dist/utils";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";
import { IdPrefix, PrefixLen } from "../../App";

function Withdrawal_Payment_Reports() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);

  const [dataOutput, setdataOutput] = useState([]);
  const [connected, setconnected] = useState(
    "Wallet is not connected..!..Wait...",
  );

  const [Uid, setUid] = useState("");
  const [uplineId, setuplineId] = useState("");
  const [fdate, setfdate] = useState("");
  const [Tdate, setTdate] = useState("");
  const [Currency, setCurrency] = useState("");
  const [totalrecord, settotalrecord] = useState(0);
  let mainAccount = "";

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/PaidWithdrawalList",
        {
          loginid: userId,
          uid: Uid.slice(PrefixLen),
          uplineid: uplineId.slice(PrefixLen),
          Fdate: fdate,
          Tdate: Tdate,
          status: 2,
          type: Currency,
          pageIndex: currentPage,
          pageSize: listPerpage,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.clear();
      //console.log("responceRight?.data?.data-->", responceRight?.data);
      settotalrecord(responceRight?.data?.dataOut?.totalRecord);
      setdataOutput(responceRight?.data.dataOut);
      responceRight = responceRight?.data?.data[0];
      setleftreferralApi([]);
      let array = [];
      responceRight.forEach((item, index) => {
        array.push({
          sr: item.row,
          id: item.id,
          uid: `${IdPrefix}${item.uid}`,
          Name: item.Name,
          address: item.wallet,
          Request_amount: item.request_amount,
          adminCharge: item.admincharge,
          paidamount: item.amount,
          tokenvalue: item.tokenvalue,
          req_date: item.date,
          tdate: item.tdate,
          approve_date: item.approve_date,
          cancel_date: item.cancel_date,
          status: item.status,
          remark: item.remark,
          trans_type: item.trans_type,
          Astatus: item?.Astatus,
          Wtype: item?.Wtype,
          holder: item?.holder,
          accountnumber: item?.accountnumber,
          ifsc: item?.ifsc,
          bank_name: item?.bank_name,
          branch: item?.branch,
          cancelremark: `${item.status == "Rejected" ? item.txn : ""}`,
          usdt_txn: (
            <>
              <a href={`https://bscscan.com/tx/${item.txn}`} target="_blank">
                {" "}
                View USDT TXN
              </a>
            </>
          ),
          token_txn: (
            <>
              <a href={`https://bscscan.com/tx/${item.txn}`} target="_blank">
                {" "}
                View Token TXN
              </a>
            </>
          ),
        });
        setleftreferralApi(array);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/PaidWithdrawalList",
        {
          loginid: userId,
          uid: Uid || 0,
          uplineid: uplineId || 0,
          Fdate: fdate,
          Tdate: Tdate,
          status: 2,
          type: Currency,
          pageIndex: 1,
          pageSize: 999999,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      responceRight = responceRight?.data?.data?.[0];
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          id: item.id,
          UserID: item.uid,
          Address: item.wallet,
          Request_Amount: item.Request_amount,
          adminCharge: item.admincharge,
          paidamount: item.amount,
          Req_Date: item.req_date,
          Approve_Date: item.approve_date,
          Cancel_Date: item.cancel_date,
          Status: item.status,
          Remark: item.remark,
          TXN: item.txn,
          Wtype: item.Wtype,
          holder: item?.holder,
          accountnumber: item?.accountnumber,
          ifsc: item?.ifsc,
          bank_name: item?.bank_name,
          branch: item?.branch,
        });
      });

      const fileName = "PaidWithdrawal";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  useEffect(() => {
    referral_API();
  }, [Currency, listPerpage, currentPage]);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi;

  var [my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "uid" },
      { Header: "Name", accessor: "Name" },
      { Header: "Request Amount", accessor: "Request_amount" },
      { Header: "Deduction", accessor: "adminCharge" },
      { Header: "Withdrawal", accessor: "paidamount" },
      { Header: "holder", accessor: "holder" },
      { Header: "A/c No.", accessor: "accountnumber" },
      { Header: "Ifsc", accessor: "ifsc" },
      { Header: "Bank Name", accessor: "bank_name" },
      { Header: "Branch Name", accessor: "branch" },
      { Header: "Request Date", accessor: "req_date" },
      // { Header: "Astatus", accessor: "Astatus" },
      { Header: "Paid Date", accessor: "tdate" },
      { Header: "Remark", accessor: "remark" },
      // { Header: "Currency", accessor: "Wtype" },
      { Header: "Cancel Date", accessor: "cancel_date" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Paid Bonus Withdrawal Report</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={Uid}
                        onChange={(e) => setUid(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter UserId"
                        maxLength={6}
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={uplineId}
                        onChange={(e) => setuplineId(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter UplineId"
                        maxLength={6}
                      />
                    </div>
                    {/* <div class="col-md-1">
                      <select
                        name="Plan"
                        className="form-control"
                        value={Currency}
                        onChange={(e) => {
                          setCurrency(e.target.value);
                        }}
                      >
                        <option value="">All</option>
                        <option value="USDT">USDT</option>
                        <option value="USDC">USDC</option>
                      </select>
                    </div> */}
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setfdate(e.target.value)}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setTdate(e.target.value)}
                        id="Tdate"
                        name="Tdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-1">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Search"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API_Export();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Export to Excel"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 ">
                      <label>
                        {/* Total Requested Amount (USDT) : {dataOutput?.TotalUsd}
                        <br /> */}
                        Total Withdrawal : {dataOutput?.TotalWithdrawlUsd}
                      </label>{" "}
                    </div>
                  </div>
                  {isLoading ? (
                    <Spinner />
                  ) : (
                    <div className="col-md-12">
                      <Table data={currentPostleft} columns={my_team.cols} />

                      <Table_Buttons
                        indexOfFirstPage={indexOfFirstPage}
                        indexOfLastPost={indexOfLastPost}
                        setcurrentPage={setcurrentPage}
                        currentPage={currentPage}
                        totalData={totalrecord}
                        listPerpage={listPerpage}
                        handleRowsPerPageChange={setlistPerpage}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Withdrawal_Payment_Reports;
